var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],staticClass:"gl-shrink-0",attrs:{"title":_vm.title,"aria-label":_vm.title,"variant":"info"}},[_vm._v("\n  "+_vm._s(_vm.__('Archived'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }